import { Controller } from "@hotwired/stimulus";
import { dropdownElement } from "../utils/misc";

export default class extends Controller {
  static targets = ["dropdownList"];
  static classes = ["visible"];

  connect() {
    dropdownElement(this.element.id).on("show.bs.dropdown", () => {
      this.dropdownListTarget.classList.add(this.visibleClass);
    });

    dropdownElement(this.element.id).on("hide.bs.dropdown", () => {
      this.dropdownListTarget.classList.remove(this.visibleClass);
    });
  }
}
